import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { UsersIcon, XIcon, PlusIcon, MinusIcon } from '../utils/icons';
import { getTeamAvatar } from '../utils/teamAvatars';
import './TeamSetup.css';

const funnyTeamNames = [
  'David\'s Mighty Men', 'Moses\' Squad', 'Gideon\'s Gang', 'Noah\'s Crew',
  'Paul\'s Posse', 'Peter\'s Pack', 'Joshua\'s Warriors', 'Elijah\'s Eagles',
  'Ruth\'s Rebels', 'Esther\'s Elite', 'Daniel\'s Dragons', 'Samuel\'s Saints',
  'Mary\'s Marvels', 'Martha\'s Mightys', 'John\'s Jedis', 'Luke\'s Legends'
];

export default function TeamSetup({ isOpen, onClose, onSetupTeams }) {
  const { t } = useLanguage();
  const [teamCount, setTeamCount] = useState(2);
  const [teamNames, setTeamNames] = useState([
    funnyTeamNames[0], 
    funnyTeamNames[1]
  ]);

  const handleTeamCountChange = (newCount) => {
    const count = Math.max(2, Math.min(8, newCount));
    setTeamCount(count);
    
    const newNames = Array.from({ length: count }, (_, i) => 
      teamNames[i] || funnyTeamNames[i] || `Team ${i + 1}`
    );
    setTeamNames(newNames);
  };

  const handleTeamNameChange = (index, name) => {
    const newNames = [...teamNames];
    newNames[index] = name;
    setTeamNames(newNames);
  };

  const handleSetup = () => {
    onSetupTeams(teamNames.slice(0, teamCount));
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="team-setup-overlay">
      <div className="team-setup-modal">
        <div className="team-setup-header">
          <div className="team-setup-title">
            <UsersIcon />
            <h2>{t('teamMode.setup.title', 'Team Mode Setup')}</h2>
          </div>
          <button onClick={onClose} className="team-setup-close">
            <XIcon />
          </button>
        </div>

        <div className="team-setup-content">
          <div className="team-count-section">
            <label>{t('teamMode.setup.teamCount', 'Number of Teams')} (2-8)</label>
            <div className="team-count-controls">
              <button 
                onClick={() => handleTeamCountChange(teamCount - 1)}
                disabled={teamCount <= 2}
              >
                <MinusIcon />
              </button>
              <span className="team-count-display">{teamCount}</span>
              <button 
                onClick={() => handleTeamCountChange(teamCount + 1)}
                disabled={teamCount >= 8}
              >
                <PlusIcon />
              </button>
            </div>
          </div>

          <div className="team-names-section">
            <label>{t('teamMode.setup.teamNames', 'Team Names')}</label>
            <div className="team-names-list">
              {Array.from({ length: teamCount }, (_, i) => (
                <div key={i} className="team-name-input">
                  <div className="team-avatar-indicator">
                    <img 
                      src={getTeamAvatar(i)} 
                      alt={`Team ${i + 1} avatar`}
                      className="team-avatar-preview"
                    />
                  </div>
                  <input
                    type="text"
                    value={teamNames[i] || ''}
                    onChange={(e) => handleTeamNameChange(i, e.target.value)}
                    placeholder={`Team ${i + 1}`}
                    maxLength={20}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="team-setup-actions">
          <button onClick={onClose} className="btn-secondary">
            {t('common.cancel', 'Cancel')}
          </button>
          <button onClick={handleSetup} className="btn-primary">
            {t('teamMode.setup.start', 'Start Team Game')}
          </button>
        </div>
      </div>
    </div>
  );
}